import React from 'react';



const querystring = require('querystring');



var parse = require('url-parse');







class LinkHelper extends React.Component {







    getTokenFragment(currentSession, expires_in = 3600, token_type = "Bearer") {







        if (typeof currentSession !== 'undefined') {



            if (



                (typeof currentSession.idToken !== 'undefined') &&



                (typeof currentSession.accessToken !== 'undefined')) {







                const params = {



                    id_token: currentSession.idToken.jwtToken,



                    access_token: currentSession.accessToken.jwtToken,



                    expires_in: expires_in,



                    token_type: token_type



                }



                if (this.getCurAuthTenandid !== null) {



                    params.pac_selected_tenant_id = this.getCurAuthTenandid();



                }







                return "#" + querystring.stringify(params);



            }



        }



    }



    getCurAuthTenandid() {



        return window.sessionStorage.getItem("pac_selected_tenant_id");



        //  return 'fd9b1adc-21fa-4c6b-a3db-833a504607d0';



    }











    extractPacTenantIdFromUrl(url) {







        let pacTenantId = null;







        const hasPacTenantId = !!(parse(url).hash || '#')



            .substr(1)



            .split('&')



            .map(entry => entry.split('='))



            .find(([k]) => k === 'pac_selected_tenant_id');











        if (!hasPacTenantId) {



            return pacTenantId;



        }







        const queryParamPairs = (parse(url).hash || '#')



            .substr(1)



            .split('&')



            .map(entry => entry.split('='));







        for (let i = 0; i < queryParamPairs.length; i++) {



            // select only the param pairs whose first element is pac_selected_tenant_id



            if (queryParamPairs[i][0] == 'pac_selected_tenant_id') {



                // select only param pairs that have exactly 2 elements - key and value 



                if (queryParamPairs[i].length == 2) {



                    pacTenantId = queryParamPairs[i][1];



                }



            }



        }







        console.debug('PAC TENANT ID: ', pacTenantId);



        return pacTenantId;



    }











    addTenantIdUrlFragment(url = window.location.href) {



        let pacTenantId = this.extractPacTenantIdFromUrl(url);



        if (pacTenantId !== null) {



            console.debug('PAC TENANT ID - STORING TO SESSION STORAGE: ', pacTenantId);



            window.sessionStorage.setItem('pac_selected_tenant_id', pacTenantId);



        }



    }











    ORIG_addTenantIdUrlFragment() {



        //window.location.href="https://7d1e81843d794b19b0a47436c475e9b4.vfs.cloud9.us-west-2.amazonaws.com/#id_token=eyJraWQiOiJNZjU5VmxYdmZaMkE4ZEg0YlY3ZjZlSWFvbkc4cVdQSlVcL3NDOUFsOW1Qcz0iLCJhbGciOiJSUzI1NiJ9.eyJhdF9oYXNoIjoiWmtVOHZ4ZGVNSW5NM0RVd1FWdEJfdyIsInBhY19maXJzdF9uYW1lIjoiU2hyYXZhbiIsInN1YiI6ImU4ZGMzY2I3LWE3MGQtNDZjYS1iNTc0LWI2NWUwOTM1YjkxZSIsImNvZ25pdG86Z3JvdXBzIjpbInF1YWxpdHlfbWFuYWdlbWVudCIsInVzLXdlc3QtMl8xZjBWSFJUWjlfUGFuYXNvbmljLmFlcm8iXSwiZW1haWxfdmVyaWZpZWQiOmZhbHNlLCJwYWNfdGVuYW50X2lkIjoiOTAzYTQyYmMtOTg1ZS00MGQxLTljNzItMzJiOGMyZTMzMzk3IiwicGFjX3VzZXJfcG9vbF9kb21haW4iOiJwYW5hc2t5LXBhbmFzb25pY2Flcm8taWRhbS11c2VycG9vbCIsImlzcyI6Imh0dHBzOlwvXC9jb2duaXRvLWlkcC51cy13ZXN0LTIuYW1hem9uYXdzLmNvbVwvdXMtd2VzdC0yXzFmMFZIUlRaOSIsInBhY19hcHBfY2xpZW50X2lkIjoiNjduZmpmMGRodHY3aWs1YWV0OGNvbGN1a2kiLCJjb2duaXRvOnVzZXJuYW1lIjoiUGFuYXNvbmljLmFlcm9fU2hyYXZhbi5KYWRpZ2FtQHBhbmFzb25pYy5hZXJvIiwicGFjX3VzZXJfcG9vbF9pZCI6InVzLXdlc3QtMl8xZjBWSFJUWjkiLCJhdWQiOiI2N25mamYwZGh0djdpazVhZXQ4Y29sY3VraSIsImlkZW50aXRpZXMiOlt7InVzZXJJZCI6IlNocmF2YW4uSmFkaWdhbUBwYW5hc29uaWMuYWVybyIsInByb3ZpZGVyTmFtZSI6IlBhbmFzb25pYy5hZXJvIiwicHJvdmlkZXJUeXBlIjoiU0FNTCIsImlzc3VlciI6Imh0dHBzOlwvXC9zdHMud2luZG93cy5uZXRcLzEwYmJiMjQ3LTA4ZGYtNGFkMy1hNTVlLTQ3YmU3NjkzYjFkMVwvIiwicHJpbWFyeSI6InRydWUiLCJkYXRlQ3JlYXRlZCI6IjE1NTIzNDEyNzQ3MTcifV0sInBhY19sYXN0X25hbWUiOiJKYWRpZ2FtIiwidG9rZW5fdXNlIjoiaWQiLCJhdXRoX3RpbWUiOjE1NTcyNTExMjAsImV4cCI6MTU1NzI1NDcyMCwicGFjX2ljYW9fY29kZSI6InBhYyIsImlhdCI6MTU1NzI1MTEyMCwiZW1haWwiOiJTaHJhdmFuLkphZGlnYW1AcGFuYXNvbmljLmFlcm8ifQ.ct1qpTxtHqCh-U3icTgG1n-4-zU5IyncFgYmON2M5cFtbOg1Mewn63A_mmHV4WwnS5N970F5AtmIWksVnwOGRBGLZ_agBZvJRVkET4YOvukwxJ0MDum5Z60JnmpB_MEBLWvI4bHXlI2qvAcGAphCbEDuvVYbaS3z5cXTj_1gfGxdP9rlAircxdxBhFrey9TU_G1Zi4rgc8j5Ryo9F8Q5bxdvBl5xrGd4cx7HTnwoMdSPrGdYc3VBvv7_0hHGaMZbThPrbtQstQdop3B0iUInZ1izcYYey4SXd-iwpjnaT1t7hCcnm0e7146Zww4Ne6HbUMz1wUvWtblwkVKXMgviNg&access_token=eyJraWQiOiJablFTWmplM0xBazFpM3dJNEpjazdPRmE3WWppRVlQSW9yOFwvSGZSRUYrVT0iLCJhbGciOiJSUzI1NiJ9.eyJzdWIiOiJlOGRjM2NiNy1hNzBkLTQ2Y2EtYjU3NC1iNjVlMDkzNWI5MWUiLCJjb2duaXRvOmdyb3VwcyI6WyJxdWFsaXR5X21hbmFnZW1lbnQiLCJ1cy13ZXN0LTJfMWYwVkhSVFo5X1BhbmFzb25pYy5hZXJvIl0sInRva2VuX3VzZSI6ImFjY2VzcyIsInNjb3BlIjoiYXdzLmNvZ25pdG8uc2lnbmluLnVzZXIuYWRtaW4gcGhvbmUgb3BlbmlkIGVtYWlsIiwiYXV0aF90aW1lIjoxNTU3MjUxMTIwLCJpc3MiOiJodHRwczpcL1wvY29nbml0by1pZHAudXMtd2VzdC0yLmFtYXpvbmF3cy5jb21cL3VzLXdlc3QtMl8xZjBWSFJUWjkiLCJleHAiOjE1NTcyNTQ3MjAsImlhdCI6MTU1NzI1MTEyMSwidmVyc2lvbiI6MiwianRpIjoiYzJjMDI3ODUtMjI4Mi00ZGY5LWIzMWMtMDllMjNhYmEwMTAwIiwiY2xpZW50X2lkIjoiNjduZmpmMGRodHY3aWs1YWV0OGNvbGN1a2kiLCJ1c2VybmFtZSI6IlBhbmFzb25pYy5hZXJvX1NocmF2YW4uSmFkaWdhbUBwYW5hc29uaWMuYWVybyJ9.aGJp0WTJ4Fw2VYjyUJcNojl_IboU3o-gpgOAhHOngwRG2Sw_5RGhJpeB8uEYnk8CIDEpsKLXkWl0mQ4gTkiehqb9rVcitxjjKKAzsWlyalncD6um_fyVivwrQjpJe1VSywOF66JIjeR_hliqgB0asSMk8afx9brm9kVX1Nm-euTmb2Tp4hmmfiXdpxR6vvPHYfWawaLLLkuxocWADREMyZ9M-d2KgiBNM9RF668t9K9S9ss2Y50k0wFQlDqxJjgRsbPwQMLXVJbtrcy6r1B-wSij9cPT_L7vIqHkM7WpucfJZ9sDQLifNoiV065uGvD4Px-8-DEwGr2slBpdmGXhBg&expires_in=3600&token_type=Bearer&pac_selected_tenant_id=5adc0d6c-84d1-430d-9ce9-1b01bc200ada";



        //window.location.href="https://7d1e81843d794b19b0a47436c475e9b4.vfs.cloud9.us-west-2.amazonaws.com/#id_token=eyJraWQiOiJNZjU5VmxYdmZaMkE4ZEg0YlY3ZjZlSWFvbkc4cVdQSlVcL3NDOUFsOW1Qcz0iLCJhbGciOiJSUzI1NiJ9.eyJhdF9oYXNoIjoiWmtVOHZ4ZGVNSW5NM0RVd1FWdEJfdyIsInBhY19maXJzdF9uYW1lIjoiU2hyYXZhbiIsInN1YiI6ImU4ZGMzY2I3LWE3MGQtNDZjYS1iNTc0LWI2NWUwOTM1YjkxZSIsImNvZ25pdG86Z3JvdXBzIjpbInF1YWxpdHlfbWFuYWdlbWVudCIsInVzLXdlc3QtMl8xZjBWSFJUWjlfUGFuYXNvbmljLmFlcm8iXSwiZW1haWxfdmVyaWZpZWQiOmZhbHNlLCJwYWNfdGVuYW50X2lkIjoiOTAzYTQyYmMtOTg1ZS00MGQxLTljNzItMzJiOGMyZTMzMzk3IiwicGFjX3VzZXJfcG9vbF9kb21haW4iOiJwYW5hc2t5LXBhbmFzb25pY2Flcm8taWRhbS11c2VycG9vbCIsImlzcyI6Imh0dHBzOlwvXC9jb2duaXRvLWlkcC51cy13ZXN0LTIuYW1hem9uYXdzLmNvbVwvdXMtd2VzdC0yXzFmMFZIUlRaOSIsInBhY19hcHBfY2xpZW50X2lkIjoiNjduZmpmMGRodHY3aWs1YWV0OGNvbGN1a2kiLCJjb2duaXRvOnVzZXJuYW1lIjoiUGFuYXNvbmljLmFlcm9fU2hyYXZhbi5KYWRpZ2FtQHBhbmFzb25pYy5hZXJvIiwicGFjX3VzZXJfcG9vbF9pZCI6InVzLXdlc3QtMl8xZjBWSFJUWjkiLCJhdWQiOiI2N25mamYwZGh0djdpazVhZXQ4Y29sY3VraSIsImlkZW50aXRpZXMiOlt7InVzZXJJZCI6IlNocmF2YW4uSmFkaWdhbUBwYW5hc29uaWMuYWVybyIsInByb3ZpZGVyTmFtZSI6IlBhbmFzb25pYy5hZXJvIiwicHJvdmlkZXJUeXBlIjoiU0FNTCIsImlzc3VlciI6Imh0dHBzOlwvXC9zdHMud2luZG93cy5uZXRcLzEwYmJiMjQ3LTA4ZGYtNGFkMy1hNTVlLTQ3YmU3NjkzYjFkMVwvIiwicHJpbWFyeSI6InRydWUiLCJkYXRlQ3JlYXRlZCI6IjE1NTIzNDEyNzQ3MTcifV0sInBhY19sYXN0X25hbWUiOiJKYWRpZ2FtIiwidG9rZW5fdXNlIjoiaWQiLCJhdXRoX3RpbWUiOjE1NTcyNTExMjAsImV4cCI6MTU1NzI1NDcyMCwicGFjX2ljYW9fY29kZSI6InBhYyIsImlhdCI6MTU1NzI1MTEyMCwiZW1haWwiOiJTaHJhdmFuLkphZGlnYW1AcGFuYXNvbmljLmFlcm8ifQ.ct1qpTxtHqCh-U3icTgG1n-4-zU5IyncFgYmON2M5cFtbOg1Mewn63A_mmHV4WwnS5N970F5AtmIWksVnwOGRBGLZ_agBZvJRVkET4YOvukwxJ0MDum5Z60JnmpB_MEBLWvI4bHXlI2qvAcGAphCbEDuvVYbaS3z5cXTj_1gfGxdP9rlAircxdxBhFrey9TU_G1Zi4rgc8j5Ryo9F8Q5bxdvBl5xrGd4cx7HTnwoMdSPrGdYc3VBvv7_0hHGaMZbThPrbtQstQdop3B0iUInZ1izcYYey4SXd-iwpjnaT1t7hCcnm0e7146Zww4Ne6HbUMz1wUvWtblwkVKXMgviNg&access_token=eyJraWQiOiJablFTWmplM0xBazFpM3dJNEpjazdPRmE3WWppRVlQSW9yOFwvSGZSRUYrVT0iLCJhbGciOiJSUzI1NiJ9.eyJzdWIiOiJlOGRjM2NiNy1hNzBkLTQ2Y2EtYjU3NC1iNjVlMDkzNWI5MWUiLCJjb2duaXRvOmdyb3VwcyI6WyJxdWFsaXR5X21hbmFnZW1lbnQiLCJ1cy13ZXN0LTJfMWYwVkhSVFo5X1BhbmFzb25pYy5hZXJvIl0sInRva2VuX3VzZSI6ImFjY2VzcyIsInNjb3BlIjoiYXdzLmNvZ25pdG8uc2lnbmluLnVzZXIuYWRtaW4gcGhvbmUgb3BlbmlkIGVtYWlsIiwiYXV0aF90aW1lIjoxNTU3MjUxMTIwLCJpc3MiOiJodHRwczpcL1wvY29nbml0by1pZHAudXMtd2VzdC0yLmFtYXpvbmF3cy5jb21cL3VzLXdlc3QtMl8xZjBWSFJUWjkiLCJleHAiOjE1NTcyNTQ3MjAsImlhdCI6MTU1NzI1MTEyMSwidmVyc2lvbiI6MiwianRpIjoiYzJjMDI3ODUtMjI4Mi00ZGY5LWIzMWMtMDllMjNhYmEwMTAwIiwiY2xpZW50X2lkIjoiNjduZmpmMGRodHY3aWs1YWV0OGNvbGN1a2kiLCJ1c2VybmFtZSI6IlBhbmFzb25pYy5hZXJvX1NocmF2YW4uSmFkaWdhbUBwYW5hc29uaWMuYWVybyJ9.aGJp0WTJ4Fw2VYjyUJcNojl_IboU3o-gpgOAhHOngwRG2Sw_5RGhJpeB8uEYnk8CIDEpsKLXkWl0mQ4gTkiehqb9rVcitxjjKKAzsWlyalncD6um_fyVivwrQjpJe1VSywOF66JIjeR_hliqgB0asSMk8afx9brm9kVX1Nm-euTmb2Tp4hmmfiXdpxR6vvPHYfWawaLLLkuxocWADREMyZ9M-d2KgiBNM9RF668t9K9S9ss2Y50k0wFQlDqxJjgRsbPwQMLXVJbtrcy6r1B-wSij9cPT_L7vIqHkM7WpucfJZ9sDQLifNoiV065uGvD4Px-8-DEwGr2slBpdmGXhBg&expires_in=3600&token_type=Bearer&pac_selected_tenant_id=";



        //window.location.href="https://7d1e81843d794b19b0a47436c475e9b4.vfs.cloud9.us-west-2.amazonaws.com/#id_token=eyJraWQiOiJNZjU5VmxYdmZaMkE4ZEg0YlY3ZjZlSWFvbkc4cVdQSlVcL3NDOUFsOW1Qcz0iLCJhbGciOiJSUzI1NiJ9.eyJhdF9oYXNoIjoiWmtVOHZ4ZGVNSW5NM0RVd1FWdEJfdyIsInBhY19maXJzdF9uYW1lIjoiU2hyYXZhbiIsInN1YiI6ImU4ZGMzY2I3LWE3MGQtNDZjYS1iNTc0LWI2NWUwOTM1YjkxZSIsImNvZ25pdG86Z3JvdXBzIjpbInF1YWxpdHlfbWFuYWdlbWVudCIsInVzLXdlc3QtMl8xZjBWSFJUWjlfUGFuYXNvbmljLmFlcm8iXSwiZW1haWxfdmVyaWZpZWQiOmZhbHNlLCJwYWNfdGVuYW50X2lkIjoiOTAzYTQyYmMtOTg1ZS00MGQxLTljNzItMzJiOGMyZTMzMzk3IiwicGFjX3VzZXJfcG9vbF9kb21haW4iOiJwYW5hc2t5LXBhbmFzb25pY2Flcm8taWRhbS11c2VycG9vbCIsImlzcyI6Imh0dHBzOlwvXC9jb2duaXRvLWlkcC51cy13ZXN0LTIuYW1hem9uYXdzLmNvbVwvdXMtd2VzdC0yXzFmMFZIUlRaOSIsInBhY19hcHBfY2xpZW50X2lkIjoiNjduZmpmMGRodHY3aWs1YWV0OGNvbGN1a2kiLCJjb2duaXRvOnVzZXJuYW1lIjoiUGFuYXNvbmljLmFlcm9fU2hyYXZhbi5KYWRpZ2FtQHBhbmFzb25pYy5hZXJvIiwicGFjX3VzZXJfcG9vbF9pZCI6InVzLXdlc3QtMl8xZjBWSFJUWjkiLCJhdWQiOiI2N25mamYwZGh0djdpazVhZXQ4Y29sY3VraSIsImlkZW50aXRpZXMiOlt7InVzZXJJZCI6IlNocmF2YW4uSmFkaWdhbUBwYW5hc29uaWMuYWVybyIsInByb3ZpZGVyTmFtZSI6IlBhbmFzb25pYy5hZXJvIiwicHJvdmlkZXJUeXBlIjoiU0FNTCIsImlzc3VlciI6Imh0dHBzOlwvXC9zdHMud2luZG93cy5uZXRcLzEwYmJiMjQ3LTA4ZGYtNGFkMy1hNTVlLTQ3YmU3NjkzYjFkMVwvIiwicHJpbWFyeSI6InRydWUiLCJkYXRlQ3JlYXRlZCI6IjE1NTIzNDEyNzQ3MTcifV0sInBhY19sYXN0X25hbWUiOiJKYWRpZ2FtIiwidG9rZW5fdXNlIjoiaWQiLCJhdXRoX3RpbWUiOjE1NTcyNTExMjAsImV4cCI6MTU1NzI1NDcyMCwicGFjX2ljYW9fY29kZSI6InBhYyIsImlhdCI6MTU1NzI1MTEyMCwiZW1haWwiOiJTaHJhdmFuLkphZGlnYW1AcGFuYXNvbmljLmFlcm8ifQ.ct1qpTxtHqCh-U3icTgG1n-4-zU5IyncFgYmON2M5cFtbOg1Mewn63A_mmHV4WwnS5N970F5AtmIWksVnwOGRBGLZ_agBZvJRVkET4YOvukwxJ0MDum5Z60JnmpB_MEBLWvI4bHXlI2qvAcGAphCbEDuvVYbaS3z5cXTj_1gfGxdP9rlAircxdxBhFrey9TU_G1Zi4rgc8j5Ryo9F8Q5bxdvBl5xrGd4cx7HTnwoMdSPrGdYc3VBvv7_0hHGaMZbThPrbtQstQdop3B0iUInZ1izcYYey4SXd-iwpjnaT1t7hCcnm0e7146Zww4Ne6HbUMz1wUvWtblwkVKXMgviNg&access_token=eyJraWQiOiJablFTWmplM0xBazFpM3dJNEpjazdPRmE3WWppRVlQSW9yOFwvSGZSRUYrVT0iLCJhbGciOiJSUzI1NiJ9.eyJzdWIiOiJlOGRjM2NiNy1hNzBkLTQ2Y2EtYjU3NC1iNjVlMDkzNWI5MWUiLCJjb2duaXRvOmdyb3VwcyI6WyJxdWFsaXR5X21hbmFnZW1lbnQiLCJ1cy13ZXN0LTJfMWYwVkhSVFo5X1BhbmFzb25pYy5hZXJvIl0sInRva2VuX3VzZSI6ImFjY2VzcyIsInNjb3BlIjoiYXdzLmNvZ25pdG8uc2lnbmluLnVzZXIuYWRtaW4gcGhvbmUgb3BlbmlkIGVtYWlsIiwiYXV0aF90aW1lIjoxNTU3MjUxMTIwLCJpc3MiOiJodHRwczpcL1wvY29nbml0by1pZHAudXMtd2VzdC0yLmFtYXpvbmF3cy5jb21cL3VzLXdlc3QtMl8xZjBWSFJUWjkiLCJleHAiOjE1NTcyNTQ3MjAsImlhdCI6MTU1NzI1MTEyMSwidmVyc2lvbiI6MiwianRpIjoiYzJjMDI3ODUtMjI4Mi00ZGY5LWIzMWMtMDllMjNhYmEwMTAwIiwiY2xpZW50X2lkIjoiNjduZmpmMGRodHY3aWs1YWV0OGNvbGN1a2kiLCJ1c2VybmFtZSI6IlBhbmFzb25pYy5hZXJvX1NocmF2YW4uSmFkaWdhbUBwYW5hc29uaWMuYWVybyJ9.aGJp0WTJ4Fw2VYjyUJcNojl_IboU3o-gpgOAhHOngwRG2Sw_5RGhJpeB8uEYnk8CIDEpsKLXkWl0mQ4gTkiehqb9rVcitxjjKKAzsWlyalncD6um_fyVivwrQjpJe1VSywOF66JIjeR_hliqgB0asSMk8afx9brm9kVX1Nm-euTmb2Tp4hmmfiXdpxR6vvPHYfWawaLLLkuxocWADREMyZ9M-d2KgiBNM9RF668t9K9S9ss2Y50k0wFQlDqxJjgRsbPwQMLXVJbtrcy6r1B-wSij9cPT_L7vIqHkM7WpucfJZ9sDQLifNoiV065uGvD4Px-8-DEwGr2slBpdmGXhBg&expires_in=3600&token_type=Bearer";



        const url = parse(window.location.href, true);







        if (url.hash !== 'undefined') {



            let parts = url.hash.split('&');



            let splitvalue;



            for (let i = 0; i < parts.length; i++) {



                splitvalue = parts[i].split('=')



                if (splitvalue.includes('pac_selected_tenant_id')) {



                    if (splitvalue[1] === "") {



                        if (this.getCurAuthTenandid() == null) {



                            window.sessionStorage.removeItem('pac_selected_tenant_id');



                        }



                    }



                    else {



                        window.sessionStorage.setItem('pac_selected_tenant_id', splitvalue[1]);



                        break;



                    }



                }







                splitvalue = [];



            }



        }



    }















}











export default LinkHelper;



